import { NAME } from "./constants";

export const GET_USER_LOCKS = NAME + "GET_USER_LOCKS";
export const GET_LOCK_USERS = NAME + "GET_LOCK_USERS";
export const REMOVE_PERMISSION_FOR_USER = NAME + "REMOVE_PERMISSION_FOR_USER";
